export default __webpack_public_path__ + "media/072bbf4a6992004184ead7e67195b8153388e8df164d412e9495cffeeebb569d.svg";